/**
 * @title whitelist.js: Sub-module for Global pages
 * @description This module is used to check whitelist links 
 * @dependency 
 */
define(['dialog'], function(dialog) {	
	
	var whitelist = {
			
		// initialization	
		init : function() {
			this.attachExternalClass();
		},	 
    
	    attachExternalClass : function(){
			var locHost = location.hostname;
			$('a').filter(function() {
				return this.hostname 
					&& this.hostname != locHost 
					&& !this.href.match(/^(mailto|javascript)\:/) 
					&& this.href != ''
					&& !whitelist.isOnWhiteList(this.hostname) ;
			}).addClass("external").unbind().on('click', this.bind_external);
		},

		//if hostname found in whitelist return true
		isOnWhiteList : function(hostname) {
			var retVal = false;
			if (urlWhitelist && urlWhitelist.findIndex(x => hostname.includes(x)) > -1 && domainWhiteListWithExternalPopup && domainWhiteListWithExternalPopup.findIndex(x => hostname.includes(x)) < 0){
				retVal = true;
			}
			
			return retVal;
	    },

	   	bind_external : function(event) {
	   		whitelist.createDialogBox(this.href);
	   		event.preventDefault();
	   	},
	    
	    createDialogBox : function(url) {
	    	dialog.createExtDialogBox({
	    		url : url,
	    		title : messages.JS_DIALOG_EXTERNAL_LINK,
	    		body : isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
	    		secondary : messages.JS_DIALOG_CANCEL,
	    		primary : messages.JS_DIALOG_EXTERNAL_LINK,
	    		oneTimePopup : whitelist.oneTimePopup(url)
	    	});
	    },
	   	
	    oneTimePopup : function(url){
			if(urlWarnOncePerSessionList && urlWarnOncePerSessionList.findIndex(x => url.includes(x)) > -1) {
				return true;
			} else {
				return false;
			}
	    }
		
	}//end whitelist object

	// Expose whiteList to the global scope.
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.whiteList = whitelist;
		
	return whitelist;
    
});


// WEBPACK FOOTER //
// ./js/global/whitelist.js